import useTspApiResource from "../../hooks/useTspApiResource";
import TspApiService from "../../api/tspApiService";

// GET /api/tsp/reports/<type> — filters: { from, to, journey_id, team_id,
// state_id, method, rating }. Every filter is optional; the server ignores
// ones a given report doesn't use.
export default function useTspReportsData(reportKey, filters) {
  return useTspApiResource(() => TspApiService.reports.get(reportKey, filters), [reportKey, JSON.stringify(filters)]);
}
